"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auditLogListResponseSchema = exports.auditLogFiltersSchema = exports.auditLogFilterActorSchema = exports.auditLogListQuerySchema = exports.auditLogEntrySchema = exports.auditLogRecordSchema = exports.auditLogActorSchema = exports.auditLogHttpMethodSchema = exports.auditLogActionSchema = void 0;
const zod_1 = require("zod");
const business_1 = require("./business");
const pagination_1 = require("./pagination");
exports.auditLogActionSchema = zod_1.z.enum([
    "CREATED",
    "UPDATED",
    "DELETED",
    "EXECUTED",
]);
exports.auditLogHttpMethodSchema = zod_1.z.enum([
    "POST",
    "PUT",
    "PATCH",
    "DELETE",
]);
exports.auditLogActorSchema = zod_1.z.object({
    membershipId: zod_1.z.string().uuid(),
    userId: zod_1.z.string().uuid(),
    name: zod_1.z.string().nullable(),
    email: zod_1.z.string().email().nullable(),
    role: business_1.membershipRoleSchema,
});
exports.auditLogRecordSchema = zod_1.z.object({
    type: zod_1.z.string().trim().min(1).max(80),
    id: zod_1.z.string().trim().min(1).max(191),
});
exports.auditLogEntrySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    actor: exports.auditLogActorSchema,
    action: exports.auditLogActionSchema,
    module: zod_1.z.string().trim().min(1).max(80),
    operation: zod_1.z.string().trim().min(1).max(120),
    record: exports.auditLogRecordSchema.nullable(),
    method: exports.auditLogHttpMethodSchema,
    route: zod_1.z.string().trim().min(1).max(255),
    occurredAt: zod_1.z.string().datetime({ offset: true }),
});
exports.auditLogListQuerySchema = pagination_1.paginationQuerySchema.extend({
    actorMembershipId: zod_1.z.string().uuid().optional(),
    action: exports.auditLogActionSchema.optional(),
    module: zod_1.z.string().trim().min(1).max(80).optional(),
});
exports.auditLogFilterActorSchema = exports.auditLogActorSchema.pick({
    membershipId: true,
    name: true,
    email: true,
    role: true,
});
exports.auditLogFiltersSchema = zod_1.z.object({
    actors: zod_1.z.array(exports.auditLogFilterActorSchema),
    actions: zod_1.z.array(exports.auditLogActionSchema),
    modules: zod_1.z.array(zod_1.z.string().trim().min(1).max(80)),
});
exports.auditLogListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.auditLogEntrySchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
    filters: exports.auditLogFiltersSchema,
});
//# sourceMappingURL=audit-log.js.map